<template>
    <div v-if="user.isAdmin">
        <div class="flex flex-wrap flex-col md:flex-row">
            <div class="w-full md:w-1/2">
                <h1 class="mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark">
                    <template v-if="user.isAdmin">All Events</template>
                    <template v-else>Your Events</template>
                </h1>
            </div>
            <div class="w-full md:w-1/2 md:text-right mb-5 md:mb-0">
                <router-link to="/events/create" class="button mb-2">Create Event</router-link>
            </div>
        </div>
        <div class="flex flex-wrap">
            <div class="flex-1 mb-3">
                <input type="text" placeholder="Search title, creator first name, creator last name, organization name" class="mb-4 search"
                @keyup.enter="searchEvents"
                v-model="filters.keyword">
            </div>
            <div class="w-full md:w-1/5">
                <button href="/events/create" class="button mb-2" @click.stop.prevent="searchEvents">Search</button>
            </div>
            <div class="w-full md:w-1/5">
                <button href="/events/create" class="button mb-2" @click.stop.prevent="clearSearch">Clear</button>
            </div>
        </div>
        <div class="responsive-table">
            <table class="w-full md:table-fixed">
                <thead>
                    <tr>
                        <th class="md:w-1/6">Title</th>
                        <th class="md:w-1/6">Festival</th>
                        <th class="md:w-1/6">Creating User, Organization</th>
                        <th class="md:w-1/6" @click="setFilterDate('created')">Created <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 25.5 20" class="w-4"><polygon fill='white' points="0 0 25 0 12.5 20 0 0" /></svg></th>
                        <th class="md:w-1/6" @click="setFilterDate('start')">Event Date <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 25.5 20" class="w-4"><polygon fill='white' points="0 0 25 0 12.5 20 0 0" /></svg></th>
                        <th class="text-white md:w-1/6">
                            <select class="text-white fill-current" name="status" v-model="filters.status">
                                <option value="">Status (All)</option>
                                <option value="new">Draft</option>
                                <option value="review">In Review</option>
                                <option value="published">Published</option>
                            </select>
                        </th>
                    </tr>
                </thead>
                <tr v-if="this.isSearching && this.searchedEvents && this.searchedEvents.length < 1">
                    <td colspan="5" class="text-center font-bold">No search results</td>
                </tr>
                <event-item
                    v-else
                    v-for="event in filteredEvents"
                    :key="event.id"
                    :event="event"></event-item>
            </table>
        </div>

        <div class="flex mt-8">
            <div class="w-1/2">
            <button class="mt-2"
                @click.stop.prevent="previous"
                :disabled="currentPage === 1"
                :class="{'opacity-50 cursor-not-allowed': currentPage === 1}">&lt;&lt; Previous</button>
            </div>

            <div class="w-1/2 text-right">
            <button class="mt-2"
                @click.stop.prevent="next"
                :disabled="currentPage === totalPages"
                :class="{'opacity-50 cursor-not-allowed': currentPage === totalPages}">Next &gt;&gt;</button>
            </div>
        </div>
        <div class="mt-6 text-center">
            <router-link to="/events/archive" class="button mb-2">
                View Archived Events
            </router-link>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import EventItem from "./EventItem.vue";

    export default {
        name: "EventList",
        title: "Event List",
        components: {
            "event-item": EventItem
        },
        data: () => ({
            isSearching: false,
            filters: {
                status: "",
                keyword: "",
                date: "created",
                direction: "ASC"
            },
            // filterDate: 'created',
            searchedEvents: {},
            searchMeta: {},
            searchPagination: {
                current_page: 1
            },
            // sortDirection: 'asc',
        }),
        computed: {
            ...mapGetters({
                events: "events",
                pagination: "eventPagination",
                user: "user"
            }),
            totalRecords() {
                return Object.keys(this.events).length;
            },
            filteredEvents() {
                return this.searchedEvents.length > 0
                    ? this.searchedEvents
                    : this.events;
            },
            currentPage() {
                return this.isSearching
                    ? this.searchPagination.current_page
                    : this.pagination.current_page;
            },
            totalPages() {
                return this.isSearching
                    ? this.searchPagination.last_page
                    : this.pagination.last_page;
            },
            isAsc() {
                return this.filters.direction === 'ASC' ? true : false
            }
        },
        watch: {
            user() {
                this.getEvents();
            },
            "filters.status": {
                handler: function() {
                    if (this.isSearching) {
                        this.searchPagination = {
                            current_page: 1
                        };
                        this.searchEvents();
                    } else {
                        this.$store.dispatch("getMoreEvents", this.getParams(1));
                    }
                }
            },
        },
        methods: {
            clearSearch() {
                this.filters.keyword = "";
                this.filters.status = "";
                this.searchedEvents = {};
                this.searchPagination = {
                    current_page: 1
                };
                this.isSearching = false;
            },
            setFilterDate(filterBy) {
                this.filters.direction = (this.filters.direction === 'DESC') ? 'ASC' : 'DESC';
                
                this.filters.date = filterBy

                if (this.isSearching) {
                    this.searchPagination = {
                        current_page: 1
                    };
                    this.searchEvents();
                } else {
                    this.$store.dispatch("getMoreEvents", this.getParams(1));
                }
            },
            getEvents() {
                this.$store.dispatch("getMyEvents");
            },
            getParams(page) {
                let params = {
                    "filter[keyword]": this.filters.keyword,
                    page: page,
                    filterDate: this.filters.date,
                    direction: this.filters.direction
                };

                if (this.filters.status == "published") {
                    params["published"] = true;
                } else if (this.filters.status) {
                    params["filter[status]"] = this.filters.status;
                    params["published"] = false;
                }

                return params;
            },
            next() {
                if (this.isSearching) {
                    this.searchPagination.current_page++;
                    this.searchEvents(
                        this.getParams(this.searchPagination.current_page)
                    );
                } else {
                    this.$store.dispatch(
                        "getMoreEvents",
                        this.getParams(this.currentPage + 1)
                    );
                }
                window.scrollTo(0, 0);
            },
            previous() {
                if (this.isSearching) {
                    this.searchPagination.current_page--;
                    this.searchEvents(
                        this.getParams(this.searchPagination.current_page)
                    );
                } else {
                    this.$store.dispatch(
                        "getMoreEvents",
                        this.getParams(this.currentPage - 1)
                    );
                }
                window.scrollTo(0, 0);
            },
            searchEvents() {
                this.isSearching = true;
                let params = {
                    "filter[keyword]": this.filters.keyword,
                    page: this.searchPagination.current_page
                };

                if (this.filters.status == "published") {
                    params["published"] = true;
                } else if (this.filters.status) {
                    params["filter[status]"] = this.filters.status;
                    params["published"] = false;
                }

                axios
                    .get(laroute.route("api.events.search", params))
                    .then(response => {
                        this.searchedEvents = response.data.data;
                        this.searchPagination = response.data.meta;
                    });
            },
        },
        mounted() {
            this.getEvents();
        }
    };
</script>
